import {
  Button,
} from "@mui/material";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import React from "react";
import AddIcon from "@mui/icons-material/Add";



export const CustomAddCvButton = ({
  apiRef,
  handleClickOpen,
}: // handleClickOpen,
{
  apiRef: React.RefObject<GridApiCommunity>;
  handleClickOpen: () => void;
}) => {

  return (
    <>
        <Button
      onClick={handleClickOpen}
      startIcon={<AddIcon />}
      variant="text"
      size="small"
      sx={{ textTransform: "none" }}
    >
      Add CV
    </Button>
    </>
  );
};
